module.exports = new __parcel__URL__("favicon-temp-assets-platform.1e67a3a5.png").toString();